import {LoadingController, ModalController, NavController} from "ionic-angular";
import {Http} from "@angular/http";
import {Component} from "@angular/core";
import * as moment from 'moment';

@Component({
  selector: 'page-typeform',
  templateUrl: 'typeform.html'
})
export class ChangesTypeformPage {
  changes = [];
  items = [];
  filter_category;
  constructor(
    private nav: NavController,
    public modalCtrl: ModalController,
    private http : Http,
    private loadingCtrl : LoadingController,
  ){

    this.filter_category = "s";
    this.processData();
  }

  processData(){
    let loading = this.loadingCtrl.create({
      content: 'Conectándose a Typeform...'
    });
    loading.present();
    let r = [];
    if(this.filter_category=="s"){
      this.http.get("https://api.typeform.com/v1/form/V3txWW?key=4706746ef546b7326fd4fa3365e019c23c02e6db").subscribe(resp => {
        loading.dismiss();
        let data = JSON.parse(resp["_body"]);
        for(let i=0;i<data.responses.length;i++){
          let info3 = '';
          if(data.responses[i].answers.date_40135917){
            info3 = data.responses[i].answers.date_40135917;
          }else if(data.responses[i].answers.date_40136178){
            info3 = data.responses[i].answers.date_40136178+' al '+data.responses[i].answers.date_43197969
          }else if(data.responses[i].answers.textfield_40136692){
            info3 = data.responses[i].answers.textfield_40136692;
          }

          let o = {
            'client' : data.responses[i].answers.textfield_40135272+ ' ' +data.responses[i].answers.email_40138377,
            'info' : data.responses[i].answers.list_40135567_choice,
            'date' : data.responses[i].metadata.date_submit,
            'info2' : data.responses[i].answers.list_42441896_choice,
            'info3' : info3
          }
          r.push(o);
        }
      });
    }
    if(this.filter_category=="d"){
      this.http.get("https://api.typeform.com/v1/form/NcFuPV?key=4706746ef546b7326fd4fa3365e019c23c02e6db").subscribe(resp => {
        loading.dismiss();
        let data = JSON.parse(resp["_body"]);
        console.log(data);
        for(let i=0;i<data.responses.length;i++){
          let info3 = '';
          if(data.responses[i].answers.textfield_41692593){
            info3 = data.responses[i].answers.textfield_41692593;
          }else if(data.responses[i].answers.date_40140498){
            info3 = data.responses[i].answers.date_40140498+' al '+data.responses[i].answers.date_40140528
          }else if(data.responses[i].answers.date_40140379){
            info3 = data.responses[i].answers.date_40140379;
          }

          let o = {
            'client' : data.responses[i].answers.textfield_40140137+ ' ' +data.responses[i].answers.email_40140197,
            'info' : data.responses[i].answers.list_40140345_choice,
            'date' : data.responses[i].metadata.date_submit,
            'info2' : data.responses[i].answers.textfield_40140467,
            'info3' : info3
          }
          r.push(o);
        }
      });
    }
    if(this.filter_category=="r"){
      this.http.get("https://api.typeform.com/v1/form/Yy0lLW?key=4706746ef546b7326fd4fa3365e019c23c02e6db").subscribe(resp => {
        loading.dismiss();
        let data = JSON.parse(resp["_body"]);
        console.log(data);
        for(let i=0;i<data.responses.length;i++){
          let info3 = '';
          /*if(data.responses[i].answers.textfield_41692593){
            info3 = data.responses[i].answers.textfield_41692593;
          }else if(data.responses[i].answers.date_40140498){
            info3 = data.responses[i].answers.date_40140498+' al '+data.responses[i].answers.date_40140528
          }else if(data.responses[i].answers.date_40140379){
            info3 = data.responses[i].answers.date_40140379;
          }*/

          let info2 = data.responses[i].answers.dropdown_42438777;
          (data.responses[i].answers.dropdown_42438844) ? info2 = info2 +', '+data.responses[i].answers.dropdown_42438844:'';
          (data.responses[i].answers.dropdown_42438847) ? info2 = info2 +', '+data.responses[i].answers.dropdown_42438847:'';

          let o = {
            'client' : data.responses[i].answers.textfield_40132550+ ' ' +data.responses[i].answers.email_40134306,
            'info' : data.responses[i].answers.list_Y7GeTYS4J6dO_choice,
            'date' : data.responses[i].metadata.date_submit,
            'info2' : info2,
            'info3' : data.responses[i].answers.list_40128851_choice
          }
          r.push(o);
        }
      });
    }
    this.changes = r;
    this.initializeItems();
  }

  initializeItems() {
    this.items = this.changes;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return ((item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) || (item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1));
      })
    }
  }

  filter(){

  }

  todate(date){
    return moment(date).format("DD-MM-YYYY");
  }

}



// WEBPACK FOOTER //
// ./src/pages/changes/typeform/typeform.ts